export default [
    {
        // [0]
        key: "estado",
        label: "Estado",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [1]
        key: "created_at",
        label: "Fecha de Creación",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [1]
        key: "revisor",
        label: "Revisado Por",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
]